import { ActiveAlertNotification, SeverityLevel, Site } from "@soft-db/monitoring-api-client";
import { useDateTimeFormatter } from "../../../composable/time-formatter";
import { CSVDocument } from "../../../utils/csv";

export function useAlertNotificationExporter() {
	const { t } = useI18n();
	const formatDT = useDateTimeFormatter();

	const severityLabels = computed<Record<SeverityLevel, string>>(() => ({
		error: t("alert-settings.exceedance"),
		warning: t("alert-settings.warning"),
		none: t("alert-settings.noExceedance"),
	}));

	const booleanLabel = computed<Record<"true" | "false", string>>(() => ({
		true: t("common.yes"),
		false: t("common.no"),
	}));

	function toCSV(site: Site, notifications: ActiveAlertNotification[]) {
		const csv = new CSVDocument();

		csv.add(
			[t("object.site"), site.name],
			[t("common.timezone"), site.timezone],
			[] // Empty spacing line
		);

		// Header
		csv.add([
			"ID",
			t("alert-settings.isMain"),
			t("common.data"),
			t("dashboard.startTime"),
			t("dashboard.endTime"),
			t("common.value"),
			t("alert-settings.threshold"),
			t("alert-settings.severity"),
		]);

		for (const [idx, notification] of notifications.entries()) {
			const hasMain = notification.data.some((d) => d.isMain);

			for (const [dataIdx, data] of notification.data.entries()) {
				// If there is no explicit main, we take the first element as the main
				const isMain = hasMain ? data.isMain : dataIdx === 0;

				csv.add([
					String(idx + 1),
					booleanLabel[String(isMain)],
					data.label,
					formatDT(data.startTime, site.timezone),
					formatDT(data.endTime, site.timezone),
					data.value,
					data.trigger || "",
					severityLabels.value[data.severity],
				]);
			}
		}

		const fname = `alert-history_${site.name}`;

		csv.save(fname);
	}

	return { toCSV };
}
